import { Vue, Component } from 'vue-property-decorator';
import { BoIdMapping } from '@/types/BoIdMapping';
import { findInParents } from '../helpers/objects';
import { BlockDTO } from '../model/BlockDTO';
import { WmsResource } from '../directives/resource';

@Component({
	directives: {
		WmsResource
	}
})
export class BaseComponent extends Vue {
	protected getText(key: string, params?: any[], boIdMapping?: BoIdMapping) {
		const block = findInParents(this, '$parent', 'block') as BlockDTO;
		boIdMapping = boIdMapping || findInParents(this, '$parent', 'boIdMapping') as BoIdMapping;

		return this.$store.getText(key, block.id, params, boIdMapping);
	}
}

export default BaseComponent;
